import { ExperienceItem } from "../Experience/ExperienceItem";

interface WorkExperienceSectionProps {
  experience: any[];
}

export function WorkExperienceSection({ experience }: WorkExperienceSectionProps) {
  if (!experience || !Array.isArray(experience) || experience.length === 0) {
    return null;
  }

  return (
    <div className="mb-6 sm:mb-8">
      <h4 
        className="text-lg sm:text-xl font-bold mb-4"
        style={{ 
          fontFamily: 'Inter, sans-serif',
          color: '#1D1D1D'
        }}
      >
        Work Experience
      </h4>
      <div className="space-y-4">
        {experience.slice(0, 2).map((exp: any, index: number) => (
          <ExperienceItem key={index} exp={exp} index={index} />
        ))}
      </div>
    </div>
  );
}

